import { Close } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import React from "react";
// import { currentUser } from "@shared/Helpers/encryptionHelpers";
import HashLoader from "react-spinners/HashLoader";
import axios from "axios";
import { notifyError, notifySuccess } from "@shared/Toast/toast";
import { currentUser } from "@shared/Helpers/encryptionHelpers";
import { api_url } from "@/constants/base_url";
import { COLORS } from "@/constants/Colors/colors";
import { useSelector } from "react-redux";

function DeleteBook({ bookId, closeNote, noteBook, refetch }) {
 const lang = useSelector((state) => state?.global?.lang);
  const globalState = useSelector((state) => state?.global);
  const { mutate, isPending, error, isError } = useMutation({
    mutationFn: () =>
      axios.delete(`${api_url}book/deleteBook?book_id=${bookId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser()?.token}`,
          lang,
        },
      }),
    onSuccess: () => {
      closeNote();
      refetch();
      notifySuccess(lang == "ar" ? "تم حذف الكتاب" : "Delete book succefully");
    },
    onError: () => {
      notifyError(
        lang == "ar"
          ? "حدث خطأ اثناء تنفيذ المهمة"
          : "An error occurred while executing the task"
      );
    },
  });

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          bgcolor: "#000000ab",
          zIndex: "1501",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          transition: "0.3s",
          opacity: noteBook === "del-book" ? "1" : "0",
          visibility: noteBook === "del-book" ? "visible" : "hidden",
        }}
      >
        <Box
          sx={{
            bgcolor: globalState?.isDarkMode ? COLORS.DARK_GRAY : "white",
            padding: "30px",
            borderRadius: "10px",
            width: "400px",
            height: "auto",
            textAlign: "center",
            position: "relative",
            transition: "0.3s",
            opacity: noteBook === "del-book" ? "1" : "0",
            transform: noteBook === "del-book" ? "scale(1)" : "scale(0)",
          }}
        >
          <div
            className="close-btn"
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 100,
            }}
          >
            <Close
              onClick={closeNote}
              sx={{
                color: "black",
                width: 30,
                height: 30,
                transition: "0.4s",
                cursor: "pointer",
                "&:hover": {
                  color: COLORS.PRIMARY.MAIN,
                },
              }}
            />
          </div>

          <Typography
            fontFamily={"Noor-bold"}
            fontSize={30}
            sx={{ textShadow: `0px 3px 0px ${COLORS.PRIMARY.MAIN}` }}
            color={globalState?.isDarkMode ? COLORS.WHITE : COLORS.BLACK}
          >
            {lang == "ar"
              ? "هل تريد حذف الكتاب"
              : "Do you want to delete the book?"}
          </Typography>

          <Box
            mt={5}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alidngItems: "center",
            }}
          >
            <Button
              onClick={() => mutate()}
              sx={{
                padding: "7px 20px",
                width: "49%",
                bgcolor: "darkred",
                color: "white",
                trnsition: "0.4s",
                "&:hover": {
                  bgcolor: "red",
                },
              }}
            >
              {isPending ? (
                <HashLoader color="#ffffff" size={24} />
              ) : lang == "ar" ? (
                "أوافق"
              ) : (
                "Accept"
              )}
            </Button>
            <Button
              onClick={closeNote}
              sx={{
                padding: "7px 20px",
                width: "49%",
                bgcolor: "gray",
                color: "white",
                trnsition: "0.4s",
                "&:hover": {
                  bgcolor: "lightgray",
                },
              }}
            >
              {lang == "ar" ? "الغاء" : "Cancel"}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default DeleteBook;
